'use client';
import { useEffect } from 'react';
import { writeListChrome, type ListChrome, type ListKind } from './listPrefs';

/**
 * 마켓 기본 목록 꼴을 쿠키에 적어 두는 자리 — **아무것도 그리지 않는다**.
 *
 * 셸(layout)이 어차피 받아 오는 `listStyle` 에서 뼈대가 쓸 값만 브라우저에 남긴다. 그러면
 * 목록 뼈대(`loading.tsx`)가 **API 를 부르지 않고** 카드형·리스트형은 물론 제목 아래
 * 줄까지 실물대로 그릴 수 있다(2026-08-28 사용자 지시 — 뼈대 하나 그리자고 요청을 더 내지
 * 않는다 · 2026-08-31 줄 어긋남을 잡으며 값이 넷으로 늘었다).
 *
 * 셸에 한 번만 둔다. 값이 그대로면 쿠키를 다시 쓰지 않는다.
 */
export function ViewDefaults({ chrome }: { chrome: Record<ListKind, ListChrome> }) {
  useEffect(() => { writeListChrome(chrome); }, [chrome]);
  return null;
}
